import { Modal } from "@mui/material";
import React from "react";

import * as Styled from "./styles";
import { Close as CloseIcon } from "@mui/icons-material";

type BaseModalProps = {
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
  confirmationCallback?: () => void;
  cancellationCallback?: () => void;
  confirmationText?: string;
  cancellationText?: string;
  title?: string;
};

const BaseModal: React.FC<BaseModalProps> = ({
  open,
  onClose,
  children,
  confirmationCallback,
  cancellationCallback,
  confirmationText,
  cancellationText,
  title,
}) => {
  return (
    <Modal open={open} onClose={onClose} closeAfterTransition keepMounted>
      <Styled.Container>
        <Styled.HeaderContainer>
          <Styled.TitleTypography>{title || "Title"}</Styled.TitleTypography>
          <CloseIcon fontSize="small" color="inherit" onClick={onClose} />
        </Styled.HeaderContainer>
        <Styled.ContentContainer>{children}</Styled.ContentContainer>
        <Styled.ButtonsContainer>
          {cancellationCallback && (
            <Styled.CancelButton
              variant="outlined"
              onClick={cancellationCallback}
            >
              {cancellationText || "Cancel"}
            </Styled.CancelButton>
          )}
          {confirmationCallback && (
            <Styled.ConfirmButton
              variant="contained"
              onClick={confirmationCallback}
              disabled={confirmationText?.includes("...")}
            >
              {confirmationText || "Confirm"}
            </Styled.ConfirmButton>
          )}
        </Styled.ButtonsContainer>
      </Styled.Container>
    </Modal>
  );
};

export default BaseModal;
